export default __webpack_public_path__ + "static/media/recharge-account.1cdfb204.svg";